export default "__VITE_ASSET__BxtluhaX__"